import { render, staticRenderFns } from "./district.vue?vue&type=template&id=2db31266&scoped=true&"
import script from "./district.js?vue&type=script&lang=js&"
export * from "./district.js?vue&type=script&lang=js&"
import style0 from "./district.vue?vue&type=style&index=0&lang=css&"
import style1 from "./district.vue?vue&type=style&index=1&id=2db31266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db31266",
  null
  
)

export default component.exports